import React, { useContext } from 'react';
import { ButtonGroup, Button } from 'react-bootstrap';
import { FaCalendarAlt, FaMapMarkerAlt, FaClipboardList, FaBoxes, FaRandom, FaBars } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import { DestinazioneContext } from '../context/DestinazioneContext';
import './MobileDaySelector.css';

const days = [
  { name: 'Lu', key: 'lunedi' },
  { name: 'Ma', key: 'martedi' },
  { name: 'Me', key: 'mercoledi' },
  { name: 'Gi', key: 'giovedi' },
  { name: 'Ve', key: 'venerdi' },
  { name: 'Sa', key: 'sabato' },
  { name: 'Do', key: 'domenica' },
];

const ADMIN_MOBILE_BAR_PATHS = ['/destinazioni', '/magazzino', '/preordini', '/smistamento', '/admin-settings'];

const MobileDaySelector = ({ selectedDay, setSelectedDay, darkMode }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { destinazione, dayActivationFlags } = useContext(DestinazioneContext);

  const isDayDisabled = (dayKey) => {
    if (destinazione?.datiDestinazione) {
      const dayMapping = {
        lunedi: 'lun_act',
        martedi: 'mar_act',
        mercoledi: 'mer_act',
        giovedi: 'gio_act',
        venerdi: 'ven_act',
        sabato: 'sab_act',
        domenica: 'dom_act',
      };
      const dayField = dayMapping[dayKey];
      if (dayField) {
        return destinazione.datiDestinazione[dayField] === '1';
      }
    }
    if (dayActivationFlags && Object.keys(dayActivationFlags).length > 0) {
      return dayActivationFlags[dayKey] === '1';
    }
    return localStorage.getItem(`dayAllZero_${dayKey}`) === '1';
  };

  const handleDayClick = (dayKey) => {
    if (location.pathname !== '/home') {
      navigate('/home');
    }
    setSelectedDay(dayKey);
  };

  const showAdminBar = ADMIN_MOBILE_BAR_PATHS.includes(location.pathname);

  if (showAdminBar) {
    const item = (path, icon, label) => (
      <Button
        variant={location.pathname === path ? 'primary' : darkMode ? 'outline-light' : 'outline-dark'}
        className="flex-grow-1"
        onClick={() => navigate(path)}
      >
        {icon}
        <div className="admin-label">{label}</div>
      </Button>
    );

    return (
      <div className={`mobile-day-selector d-print-none ${darkMode ? 'bg-dark' : 'bg-light'}`}>
        <ButtonGroup className="w-100">
          {item('/destinazioni', <FaMapMarkerAlt size={16} />, 'Destinazioni')}
          {item('/magazzino', <FaBoxes size={16} />, 'Prodotti')}
          {item('/preordini', <FaClipboardList size={16} />, 'Preordini')}
          {item('/smistamento', <FaRandom size={16} />, 'Smistamento')}
        </ButtonGroup>
      </div>
    );
  }

  return (
    <div className={`mobile-day-selector d-print-none ${darkMode ? 'bg-dark' : 'bg-light'}`}>
      <ButtonGroup className="w-100">
        {days.map((day) => {
          const isDayZero = isDayDisabled(day.key);
          const isSelected = selectedDay === day.key;
          const isSelectedAndZero = isSelected && isDayZero;
          const isSelectedAndNotZero = isSelected && !isDayZero;

          let buttonClass = 'flex-grow-1';
          if (isSelectedAndZero) buttonClass += ' disabled-selected';
          else if (isDayZero && !isSelected) buttonClass += ' disabled-not-selected';

          return (
            <Button
              key={day.key}
              variant={isSelectedAndNotZero ? 'primary' : darkMode ? 'outline-light' : 'outline-dark'}
              className={buttonClass}
              onClick={() => handleDayClick(day.key)}
              aria-label={day.key}
            >
              <div className="d-flex flex-column align-items-center">
                <FaCalendarAlt
                  size={14}
                  style={{
                    color: isSelectedAndZero || isDayZero ? '#dc3545' : undefined,
                    marginBottom: 2,
                  }}
                />
                <span className="day-label">{day.name}</span>
              </div>
            </Button>
          );
        })}
        <Button
          variant={
            location.pathname.startsWith('/documenti') || ADMIN_MOBILE_BAR_PATHS.includes(location.pathname)
              ? 'primary'
              : darkMode
                ? 'outline-light'
                : 'outline-dark'
          }
          className="flex-grow-1"
          onClick={() => window.dispatchEvent(new Event('panify-open-menu'))}
          aria-label="Menu"
        >
          <div className="d-flex flex-column align-items-center">
            <FaBars size={14} style={{ marginBottom: 2 }} />
            <span className="day-label">Menu</span>
          </div>
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default MobileDaySelector;
